import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';

interface Step1Props {
  onNext: (data: Step1Data) => void;
  initialData?: Step1Data;
}

export interface Step1Data {
  projectType: string;
  industry?: string;
  goals?: string;
}

const projectTypes = [
  { value: 'web_app', label: 'Web App', description: 'Browser-based application' },
  { value: 'mobile_app', label: 'Mobile App', description: 'iOS & Android apps' },
  { value: 'api_backend', label: 'API/Backend', description: 'Server-side services' },
  { value: 'ecommerce', label: 'E-commerce', description: 'Online store platform' },
  { value: 'dashboard', label: 'Dashboard/Portal', description: 'Admin or user portal' },
  { value: 'ai_ml', label: 'AI/ML Solution', description: 'AI-powered application' },
  { value: 'other', label: 'Other', description: 'Custom solution' },
];

export const Step1ProjectType = ({ onNext, initialData }: Step1Props) => {
  const [selectedType, setSelectedType] = useState(initialData?.projectType || '');

  const handleSubmit = () => {
    if (selectedType) {
      onNext({ projectType: selectedType });
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">What type of software do you need?</h2>
        <p className="text-gray-600 mt-2">Select the option that best describes your project</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {projectTypes.map((type) => (
          <Card
            key={type.value}
            className={`cursor-pointer transition-all ${
              selectedType === type.value
                ? 'border-blue-600 border-2 shadow-lg'
                : 'border-gray-200 hover:border-blue-300'
            }`}
            onClick={() => setSelectedType(type.value)}
          >
            <CardContent className="pt-6">
              <div className="text-center">
                <h3 className="font-semibold text-lg text-gray-900">{type.label}</h3>
                <p className="text-sm text-gray-500 mt-2">{type.description}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="flex justify-end">
        <Button
          onClick={handleSubmit}
          disabled={!selectedType}
          className="bg-blue-600 hover:bg-blue-700 text-white px-8"
        >
          Next
        </Button>
      </div>
    </div>
  );
};
